export default {
  tabs: {
    campaignInformation: '计划信息',
    otherInformation: '高级设置',
    audience: '受众画像',
    campaignIdeas: '内容创意',
  }
};
